<template>
  <div class>
    <page-title title="Склад и товары">
      <router-link :to="{name: 'StorageGoods.receipt'}">
        <el-button type="primary" size="mini">Поступление товаров</el-button>
      </router-link>
      <router-link :to="{name: 'StorageGoods.move'}">
        <el-button type="primary" size="mini" icon="el-icon-sort">Перемещение товаров</el-button>
      </router-link>
      <el-button
        v-if="state.openedTab == 'goods'"
        type="primary"
        size="mini"
        @click="printGoods"
      >Распечатать остатки</el-button>
    </page-title>
    <el-tabs v-model="state.openedTab" :value="state.openedTab" @tab-click="changeTab">
      <el-tab-pane :label="tab.name" :name="tab.tab" v-for="tab in tabs"></el-tab-pane>
    </el-tabs>
    <div class="tabs_view">
      <goods-tab v-if="state.openedTab == 'goods'" :api="goodsTabApi"></goods-tab>
      <report-tab v-if="state.openedTab == 'report'"></report-tab>
      <history-tab v-if="state.openedTab == 'history'"></history-tab>
    </div>
  </div>
</template>

<script>
import GoodsTab from "@/modules/productsStorage/components/storageAndGoods/tabs/goods";
import ReportTab from "@/modules/productsStorage/components/storageAndGoods/tabs/report";
import HistoryTab from "@/modules/productsStorage/components/storageAndGoods/tabs/history";

export default {
  name: "storage_and_goods_main",
  components: { GoodsTab, ReportTab, HistoryTab },
  data: () => ({
    state: {
      openedTab: "report"
    },
    tabs: [
      {
        name: "Отчет",
        route: "StorageGoods.main.report",
        tab: "report"
      },
      {
        name: "Товары",
        route: "StorageGoods.main.goods",
        tab: "goods"
      },
      {
        name: "История перемещений",
        route: "StorageGoods.main.history",
        tab: "history"
      }
    ],
    goodsTabApi: {}
  }),
  watch: {
    "$route.query.tab": {
      handler(value) {
        this.state.openedTab = value ? value : "report";
      }
    }
  },
  created() {
    if (this.$route.query.tab) {
      this.state.openedTab = this.$route.query.tab;
    } else {
      this.$router.push({
        name: "StorageGoods.main",
        query: { tab: "report" }
      });
    }
  },
  methods: {
    onRouteChange() {
      this.links.forEach(link => {
        link.active = this.$route.name === link.route;
      });
    },
    printGoods() {
      if (this.goodsTabApi.print) {
        this.goodsTabApi.print();
      }
      return;
    },
    changeTab(tab) {
      this.$router.push({
        name: "StorageGoods.main",
        query: { tab: tab.name }
      });
    }
  }
};
</script>

<style lang="scss">
.tabs_header {
  width: 100%;
}

.tabs_header__row {
  margin-top: 20px;
  border-bottom: 1px solid lightgrey;
  display: flex;
}

.tabs_header__row a {
  color: black;
}

.tabs_header__row a:hover {
  text-decoration: none;
}

.tabs_header__row__item {
  /*margin-right: 20px;*/
  padding: 10px 20px;
  cursor: pointer;
  /*border: 1px solid lightgrey;*/
  border-bottom: none;
  /*background: lightgrey;*/
}

.tabs_header__row__item:hover {
  border-bottom: 1px solid black;
}

.tabs_header__row__item a {
  color: lightgrey;
}

.tabs_header__row__item a:hover {
  text-decoration: none;
}

.active_item {
  border-bottom: 1px solid black;
}

.active_item a {
  color: black;
}

.tree_header {
  border-bottom: 1px solid lightgrey;
  padding-bottom: 10px;
}

.report_info {
  margin: 10px 0;
}

.products-report {
  &__head {
    &__storages {
      text-align: right;
      border-bottom: 1px solid #dcdfe6;
      padding-bottom: 10px;
    }
  }
  &__tree {
    &__name {
      float: left;
    }

    &__storages {
      float: right;
      text-align: right;
      &__item {
        display: inline-block;
        text-align: center;
        width: 150px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/productsStorage/components/storageAndGoods/main.vue